import *  as axios from 'axios';
import * as ActionTypes from '../../constants/actiontypes/funecap/teleconseillers';
import * as urls from '../../constants/webapi/backoffice/clients';
import * as partnersUrl from '../../constants/webapi/backoffice/partners';
import * as authUrls from '../../constants/webapi/auth';
import * as R from 'ramda';
import { getAuthenticationUrl } from '../../constants/webapi/auth';



export function FetchAllTeleconseillers(pageNumber, searchTerm, roles, sortByTerm, sortDesc, partnerId) {
    const page = parseInt(pageNumber);
    if (!R.isNil(pageNumber) && isNaN(page)) {
        throw new Error("pageNumber must be null or an integer");
    }
    pageNumber -= 1;

    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_TELECONSEILLERS_REQUEST });
        return axios.get(urls.usersByUrl(pageNumber, searchTerm, roles, sortByTerm, sortDesc, partnerId, ''))
            .then((response) => {
                dispatch({
                    type: ActionTypes.FETCH_TELECONSEILLERS_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_TELECONSEILLERS_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function CreateTeleconseillerByPartnerId(userDto, partnerId, role) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.CREATE_TELECONSEILLER_REQUEST });
		return axios.post(partnersUrl.usersByPartnerIdUrl(partnerId, role), userDto)
			.then((response) => {
				dispatch({
					type: ActionTypes.CREATE_TELECONSEILLER_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.CREATE_TELECONSEILLER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function UpdateTeleconseillerByPartnerId(userDto, partnerId, role) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_TELECONSEILLER_REQUEST });
		return axios.put(partnersUrl.userByIdPartnerIdUrl(partnerId, userDto.id, role), userDto)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_TELECONSEILLER_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_TELECONSEILLER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function DeleteTeleconseillerByPartnerId(userId, partnerId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_TELECONSEILLER_REQUEST });
		return axios.delete(partnersUrl.userByIdUrl(userId))
			.then((response) => {
				dispatch({
					type: ActionTypes.DELETE_TELECONSEILLER_SUCCESS,
					userId: userId,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_TELECONSEILLER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function ResetPassword(email, phoneNumber) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.RESET_PASSWORD_REQUEST });
		return axios.post(authUrls.resetPasswordEmail(), { email, phoneNumber })
			.then(() => {
				dispatch({
					type: ActionTypes.RESET_PASSWORD_SUCCESS
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.RESET_PASSWORD_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}